/* Velmont motion: scroll reveals, staggered groups and header state.
   Elements opt in with [data-reveal] ("up" default, "fade", "zoom").
   Children of [data-reveal-group] get a stagger index automatically. */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('v-motion') || !('IntersectionObserver' in window)) {
    root.classList.remove('v-motion');
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const scan = (scope = document) => {
    scope.querySelectorAll('[data-reveal-group]').forEach((group) => {
      [...group.querySelectorAll(':scope > [data-reveal], :scope > * > [data-reveal]')].forEach((el, i) => {
        el.style.setProperty('--reveal-i', Math.min(i, 8));
      });
    });
    scope.querySelectorAll('[data-reveal]:not(.is-in)').forEach((el) => io.observe(el));
  };

  const start = () => {
    scan();
    // Content injected later (filters, recommendations, theme editor)
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.('[data-reveal]')) io.observe(node);
          scan(node);
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Theme editor: show everything immediately when a section is (re)loaded
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in'));
  });

  // Header gains a soft shadow once the page scrolls
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      root.classList.toggle('v-scrolled', window.scrollY > 8);
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
